import ajax from './ajax'; // 引用二次封装ajax.js
export default {

  // 获取我的工单列表信息
  myUserRepairOrderlist (params) {
    return ajax.get('/crmform/message/userRepairInterface/myUserRepairOrderlist.ht', params);
  },
  // 获取我的工单详情信息
  myUserRepairOrderDetails (params) {
    return ajax.get('/crmform/message/userRepairInterface/myUserRepairOrderDetails.ht', params);
  },
  // 获取我的工单回复信息
  myUserRepairReplyList (params) {
    return ajax.get('/crmform/message/userRepairInterface/myUserRepairReplyList.ht', params);
  },
  // 创建我的工单
  addUserRepairOrder (params) {
    let url = `/crmform/message/userRepairInterface/addUserRepairOrder.ht?tokenId=${localStorage.getItem("dl_tokenId_bl")}`
    return ajax.postForm(url, params);
  },
  // 回复我的工单
  addUserReplyContent (params) {
    let url = `/crmform/message/userRepairInterface/addUserReplyContent.ht?tokenId=${localStorage.getItem("dl_tokenId_bl")}`
    return ajax.postForm(url, params);
  },
  // 关闭我的工单
  downUserReplyOrder (params) {
    let url = `/crmform/message/userRepairInterface/downUserReplyOrder.ht?tokenId=${localStorage.getItem("dl_tokenId_bl")}`
    return ajax.postForm(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/work.js